<!-- 生产企业管理--账号管理 -->
<template>
	<div class="container flex flex-column height-all overflow-hidden">
<!--		<div class="menuPageTitle">-->
<!--			<span class="pageTitleCur">账号管理</span>-->
<!--		</div>-->
		<!-- 顶部搜索模块 -->
		<div class="searchContainer flex-shrink">
			<baseSearch :searchData="searchData" @searchClick="searchBtnClick"/>
		</div>
		<div class="mainTable height-all border-radius-10 bg-white flex flex-column overflow-hidden">
			<!-- 添加按钮 -->
			<div class="basetableAddBtn flex-shrink">
				<el-button plain type="primary" @click="addUser('',$event)"><el-icon><Plus /></el-icon>&nbsp;添加</el-button>
			</div>
			<div class="basetableBox height-all overflow-hidden">
				<basetable tableBoxClass='basetableBox' :tableTitle="tableTitle" :tableData="tableData" :showNumber="true" :operaWidth="200" :showopera="true" :currentPage="searchDataParam.pageNo"
					:showSelection="false" :isLoading="isLoading" :total="total" :showPage="true" @current-change="currentChange">
					<template v-slot:imgUrl="scope">
						<el-image style="height: 30px;" :src="scope.scope.row.imgUrl" :preview-src-list="scope.scope.row.imgUrl" fit="cover"/>
					</template>
					<template v-slot:on_work="scope">
						<el-tag v-if="scope.scope.row.on_work == 1" class="ml-2" type="success">有效</el-tag>
						<el-tag v-if="scope.scope.row.on_work != 1" class="ml-2" type="danger">无效</el-tag>
					</template>
					<template v-slot:opera="scope">
						<el-button type="primary" size="small" plain @click="addUser(scope.scope,$event)">编辑</el-button>
						<el-button type="danger" size="small" plain @click="delUser(scope.scope,$event)">删除</el-button>
					</template>
				</basetable>
			</div>
		</div>
	</div>
</template>

<script>
	import baseSearch from "@/components/baseSearch";
	import basetable from "@/components/basetable";
	import basedialog from "@/components/basedialog";
	export default {
		name:'userManager',
		inject: ['$http', '$api', '$utils','$userUtils'],
		components: {
			baseSearch,
			basetable,
			basedialog,
		},
		data(){
			return{
				searchData:[{
					label: "用户名",
					type: "input",
					name: "name",
					value: ""
				},{
					label: "姓名",
					type: "input",
					name: "realName",
					value: ""
				}],
				tableTitle: [{
					label: '头像',
					prop: 'head_image_url',
					columnStyle: 'proImg'
				}, {
					label: '用户名',
					prop: 'name',
				}, {
					label: '会员号',
					prop: 'platformOsUserMemberNum',
				}, {
					label: '真实姓名',
					prop: 'real_name',
				}, {
					label: '电话',
					prop: 'telphone',
				}, {
					label: '有效状态',
					prop: 'on_work',
					columnStyle: 'custom'
				}, {
					label: '添加时间',
					prop: 'add_time',
					columnStyle: 'timestamp'
				}, {
					label: '更新时间',
					prop: 'utime',
					columnStyle: 'timestamp'
				}],
				tableData: [],
				searchDataParam:{
					pageSize:20,
					pageNo:1,
					// productCompanyId:"381880968134376534"
				},
				total:0,
				isLoading:true,
			}
		},
		mounted() {
			this.initData();
			//该方法提供给 添加/修改专区 提交后 刷新当前列表使用
			window["getSysUserList"] = (params) => {
				this.initData();
			}
		},
		methods:{
			/**
			 * 初始化数据
			 */
			initData(){
				this.isLoading = true;
				this.$http.post(this.$api.userListApi,this.searchDataParam).then(res=>{
					this.isLoading = false;
					if(res.code == 200){
						this.tableData = res.data == '[]' ? [] : res.data;
						this.total = res.count;
					}
				})
			},
			/**
			 * 搜索按钮
			 */
			searchBtnClick(option){
				this.searchDataParam = Object.assign(this.searchDataParam,option);
				this.searchDataParam.pageNo = 1;
				this.initData()
			},
			/**
			 * 设置页码
			 */
			currentChange(val){
				this.searchDataParam.pageNo = val;
				this.initData()
			},
			/**
			 * 删除定制产品
			 */
			delUser(scope,evt){
				let target = evt.target;
				if(target.nodeName == "SPAN"){
				  target = evt.target.parentNode;
				}
				target.blur();
				this.$confirm('确定删除当前用户吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					center:true
				}).then(() => {
					this.$http.post(this.$api.userDeleteApi,{
						keyId:scope.row.id,
					}).then(res=>{
						if(res.code == 200){
							this.$message.success('操作成功！')
							this.initData();
						}
					})
				}).catch(() => {
				
				});
			},
			/**
			 * 添加用户
			 */
			addUser(scope,evt){
				let target = evt.target;
				if(target.nodeName == "SPAN"){
				  target = evt.target.parentNode;
				}
				target.blur();
				if(scope.row){
					this.$utils.showNotModelWin('/addUser?id=' + scope.row.id,1300, 800, "newwindow");
				}else{
					this.$utils.showNotModelWin('/addUser',1300, 800, "newwindow");
				}
			}
		}
	}
</script>

<style>
    .mainCont .container{
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 12px;
        box-sizing: border-box;
    }
    .basetableAddBtn{
        margin-bottom: 12px;
    }
</style>